export const sortData = (arr, keys, orders) => {
  if (!arr || !(arr instanceof Array)) {
    return arr
  }
  if (keys instanceof Object && !(keys instanceof Array) && !(keys instanceof Function)) {
    return arr
  }
  keys = keys instanceof Array ? keys : [keys]
  orders = orders instanceof Array ? orders : [orders]
  if (keys.length <= 0) {
    return arr
  }
  const sortBy = (keys, orders) => (o1, o2) => {
    let key = keys[0]
    let order = orders[0] !== 'desc' ? 1 : -1
    let co1 = key instanceof Function ? key(o1, order) : o1[key]
    let co2 = key instanceof Function ? key(o2, order) : o2[key]
    co1 = co1 instanceof Array ? co1.length : co1
    co2 = co2 instanceof Array ? co2.length : co2
    if (co1 === null || co1 === undefined || co1 < co2) {
      return -1 * order
    } else if (co2 === null || co2 === undefined || co1 > co2) {
      return 1 * order
    } else {
      return keys.length <= 1 ? 0 : sortBy(keys.slice(1), orders.length > 0 ? orders.slice(1) : orders)(o1, o2)
    }
  }
  return [...arr].sort(sortBy(keys, orders))
}

export const dateFormat = (date, fmt) => {
  date.setHours(date.getHours() - (date.getTimezoneOffset() - (new Date()).getTimezoneOffset()) / 60)
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

export const groupBy = (ary, f, needKey = false) => {
  let groups = {}
  for (let item of ary) {
    let key = needKey ? f(item) : JSON.stringify(f(item))
    groups[key] = groups[key] || []
    groups[key].push(item)
  }
  return needKey ? groups : Object.values(groups)
}

export const splitBy = (ary, size, key, empty) => {
  let result = {}
  for (let i = 0; i < ary.length; i += size) {
    const chunk = ary.slice(i, i + size)
    result[(key || 'TEMP') + (Math.floor(i / size) + 1)] = [
      ...chunk,
      ...(empty ? Array(size - chunk.length).fill(empty) : [])
    ]
  }
  return key ? result : Object.values(result)
}

export const fileTypeCheck = (e, operation, onError) => {
  let acceptTypes = e.target.getAttribute('accept')
  acceptTypes = acceptTypes ? acceptTypes.split(',') : null
  let extension = e.target.getAttribute('extension')
  extension = extension ? extension.split(',') : null
  let match = (arys, s) => {
    for (let ary of arys) {
      let rgx = new RegExp(ary)
      if (rgx.test(s)) {
        return true
      }
    }
    return false
  }
  for (let file of e.target.files) {
    let fileType = file.type
    let fileExtension = file.name.split(/^[^.]*\./)[1]
    if (extension && !match(extension, fileExtension)) {
      e.target.value = ''
      if (onError) {
        onError(e, extension)
      }
      return
    }
    if (acceptTypes && !match(acceptTypes, fileType)) {
      e.target.value = ''
      if (onError) {
        onError(e, acceptTypes)
      }
      return
    }
  }
  operation(e)
}

export const toPriceString = price => {
  return (price + '').split('.').map(s => s.replace(/(?!^)(?=(\d{3})+($|\.))/g, ',')).join('.')
}

export const cleanObject = (input, strictMode = false) => {
  let obj = { ...input }
  for (let key in obj) {
    if (obj[key] === null || obj[key] === undefined) {
      delete obj[key]
    }
    if (obj[key] && strictMode) {
      if (obj[key] === '' || (obj[key] instanceof Array && !obj[key].length) || (typeof obj[key] === 'object' && !Object.keys(obj[key]).length && !obj[key].lastModified)) {
        delete obj[key]
      }
    }
  }
  return obj
}

export const toDivideNumber = (number, base) => {
  return number + (base - Math.abs(number) % base) * (number >= 0 ? 1 : -1)
}

export const fixNumber = (value, step, fix = 1) => {
  if (step && (value || (value === 0))) {
    const match = (step + '').match(/\.(.*?)$/)
    let len = match ? match[1].length : (step + '').match(/1e-(\d+)$/)[1]
    len = (len || 0) - -Math.log10(fix)
    value = Math.round(value * Math.pow(10, len)) / Math.pow(10, len)
  }
  return value
}

/* eslint-disable */
const _XLSX = XLSX
/* eslint-enable */

export const xlsxToJson = async files => {
  if (!files) {
    return
  }
  const getContent = file => new Promise(resolve => {
    let reader = new FileReader()
    reader.onload = e => {
      let data = e.target.result
      let wb = _XLSX.read(data, {
        type: 'binary'
      })
      resolve(_XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]))
    }
    reader.readAsBinaryString(file)
  })
  let jsons = []
  for (let file of files) {
    jsons.push(await getContent(file))
  }
  return jsons
}

export const jsonToXlsx = (datas, filename = 'excel', sheetname = 'sheet') => {
  let ws = _XLSX.utils.json_to_sheet(datas)
  let wb = _XLSX.utils.book_new()
  _XLSX.utils.book_append_sheet(wb, ws, sheetname)
  _XLSX.writeFile(wb, filename + '.xlsx')
}

export const imageReader = async (files, type = 'dataUrl', maxWidth, maxHeight) => {
  if (!files) {
    return
  }
  const getContent = file => new Promise(resolve => {
    let reader = new FileReader()
    reader.onload = async e => {
      let dataUrl = e.target.result.startsWith('data:image/') ? e.target.result : ''
      if (maxWidth || maxHeight || type === 'blob' || type === 'blobUrl') {
        resolve(await this.imageUrlReader([dataUrl], type === 'dataUrl' ? 'blobUrl' : type, maxWidth, maxHeight))
      } else if (type === 'dataUrl') {
        resolve(dataUrl)
      } else {
        resolve('')
      }
    }
    reader.readAsDataURL(file)
  })
  let content = []
  for (let file of files) {
    content.push(await getContent(file))
  }
  return content
}

export const imageUrlReader = async (urls, type = 'blobUrl', maxWidth, maxHeight) => {
  if (!urls) {
    return
  }
  const getContent = url => new Promise(resolve => {
    let img = new Image()
    img.onload = e => {
      let canvas = document.createElement('canvas')
      let targetWidth = img.width
      let targetHeight = img.height
      maxWidth = maxWidth || img.width
      maxHeight = maxHeight || img.height
      if (targetWidth > maxWidth || targetHeight > maxHeight) {
        if (targetWidth / targetHeight > maxWidth / maxHeight) {
          targetHeight = Math.round(maxWidth * (targetHeight / targetWidth))
          targetWidth = maxWidth
        } else {
          targetHeight = maxHeight
          targetWidth = Math.round(maxHeight * (targetWidth / targetHeight))
        }
      }
      canvas.width = targetWidth
      canvas.height = targetHeight
      canvas.getContext('2d').drawImage(img, 0, 0, targetWidth, targetHeight)
      canvas.toBlob(blob => {
        if (type === 'blobUrl') {
          resolve(URL.createObjectURL(blob))
        } else if (type === 'blob') {
          resolve(blob)
        }
      })
    }
    img.setAttribute('crossOrigin', 'Anonymous')
    img.src = url
  })
  let content = []
  for (let url of urls) {
    content.push(await getContent(url))
  }
  return content
}

export const getCharLength = str => {
  /* eslint-disable-next-line no-control-regex */
  let arr = str.match(/[^\x00-\xff]/ig)
  return (arr == null) ? str.length : str.length + arr.length
  /* eslint-disable-next-line no-control-regex */
}

export const subCharString = (str, length) => {
  /* eslint-disable-next-line no-control-regex */
  return str.replace(/([^\x00-\xff])/ig, '$1ゐ').substring(0, length).replace(/([^\x00-\xff])$/, '').replace(/([^\x00-\xff])ゐ/ig, '$1')
  /* eslint-disable-next-line no-control-regex */
}

export const copyToClipboard = value => {
  navigator.clipboard.writeText(value)
}

export const convertNumberCount = (_count, split = '', step, lower = false, limit) => {
  const sizeType = lower ? ['', 'k', 'm', 'b', 't', 'q'] : ['', 'K', 'M', 'B', 'T', 'Q']
  limit = limit || sizeType.length
  let type = 0
  for (; _count > 1000 && (type < limit); _count /= 1000, type++) {}
  return fixNumber(_count, step) + split + sizeType[type]
}

export const htmlencode = s => {
  let div = document.createElement('div')
  div.appendChild(document.createTextNode(s))
  return div.innerHTML
}

export const htmldecode = s => {
  let div = document.createElement('div')
  div.innerHTML = s
  return div.innerText || div.textContent
}

export const downloadFile = (fileName, urlData, target) => {
  let aLink = document.createElement('a')
  if (fileName) {
    aLink.download = fileName
  }
  if (target) {
    aLink.target = target
  }
  aLink.href = urlData
  aLink.click()
}

export const toFormdata = (object, needEmpty = false, arrayFix = '[]') => {
  let formData = new FormData()
  for (let kv of Object.entries(object)) {
    if (needEmpty || (kv[1] !== null && kv[1] !== undefined)) {
      if (kv[1] instanceof Array) {
        for (let data of kv[1]) {
          formData.append(kv[0] + arrayFix, data)
        }
      } else {
        formData.append(kv[0], kv[1])
      }
    }
  }
  return formData
}



// WEBPACK FOOTER //
// ./src/constants/global/util.js